import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { FetchApi } from "../../Api/AuthenticatedApi";

const byId = (items, label = (x) => x.name) =>
  Object.fromEntries((items || []).map((x) => [x.id, label(x)]));

// useFilterOptions loads what filter rules can pick from — tags, lists,
// campaigns (with their forms), products, sequences and the contact custom
// fields — and name lookups (id → name) for showing rules in words.
export default function useFilterOptions() {
  const { getAccessTokenSilently } = useAuth0();
  const [data, setData] = React.useState({
    tags: [], lists: [], campaigns: [], products: [], sequences: [], customFieldDefs: [],
  });

  React.useEffect(() => {
    const load = (url, key, pick = (d) => d || []) =>
      FetchApi(getAccessTokenSilently, url, (d) => setData((prev) => ({ ...prev, [key]: pick(d) })), () => {}, () => {});
    load("/api/tags/", "tags");
    load("/api/contact-lists/", "lists");
    load("/api/campaigns/?" + new URLSearchParams({ page: 0, count: 500 }), "campaigns", (d) => (d && d.campaigns) || []);
    load("/api/products/", "products");
    load("/api/sequences/", "sequences", (d) => (Array.isArray(d) ? d : []));
    load("/api/custom-fields/?entity_type=contact", "customFieldDefs");
  }, [getAccessTokenSilently]);

  return React.useMemo(() => {
    const forms = data.campaigns.flatMap((c) =>
      (c.form_variants || []).map((f) => ({ ...f, campaignName: c.name })));
    return {
      ...data,
      forms,
      names: {
        tags: byId(data.tags),
        lists: byId(data.lists),
        campaigns: byId(data.campaigns),
        forms: byId(forms, (f) => `${f.campaignName} › ${f.name || "Form"}`),
        products: byId(data.products),
        sequences: byId(data.sequences),
      },
    };
  }, [data]);
}
